import { ApolloLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'

import { Experiments, Headers } from '../types'

const buildExperimentsHeader = (
  existingHeader: string | undefined,
  experiments: Experiments,
): string => {
  const entries = Object.entries(experiments)
    .map(([key, variation]) => `${key}=${variation}`)
    .join(';')

  return existingHeader ? `${existingHeader};${entries}` : entries
}

export const createContextLink = ({
  headers,
}: {
  headers: Headers
}): ApolloLink =>
  setContext((_, previousContext) => {
    const experiments: Experiments | undefined = previousContext.experiments
    const existingExperiments = headers['mnpg-experiments']

    return {
      headers: {
        ...headers,
        ...(experiments && {
          'mnpg-experiments': buildExperimentsHeader(
            typeof existingExperiments === 'string'
              ? existingExperiments
              : undefined,
            experiments,
          ),
        }),
      },
    }
  })
